import { action, thunk } from 'easy-peasy';

import StormModel from '../interfaces/StoreModel/StormModel';
import { hurricaneAlert, hurricaneContent } from '../lib/api/services';
import { StormContent } from '../interfaces/Storm';

const emptyContent: StormContent = { prepare: null, evac: null, resources: null };

const model: StormModel = {
  alert: null,
  loading: false,
  error: '',
  lastFetchedAt: 0,
  dismissedVersions: {},
  reopenSignal: 0,
  content: emptyContent,
  contentLastFetchedAt: 0,

  setAlert: action((state, payload) => {
    state.alert = payload;
  }),
  setLoading: action((state, payload) => {
    state.loading = payload;
  }),
  setError: action((state, payload) => {
    state.error = payload;
  }),
  setLastFetchedAt: action((state, payload) => {
    state.lastFetchedAt = payload;
  }),
  incrementDismiss: action((state, version) => {
    const current = state.dismissedVersions[version] || 0;
    state.dismissedVersions = {
      ...state.dismissedVersions,
      [version]: current + 1,
    };
  }),
  resetDismissed: action((state) => {
    state.dismissedVersions = {};
  }),
  incrementReopenSignal: action((state) => {
    state.reopenSignal += 1;
  }),
  setContent: action((state, payload) => {
    state.content = payload;
  }),
  setContentLastFetchedAt: action((state, payload) => {
    state.contentLastFetchedAt = payload;
  }),

  load: thunk(async (actions) => {
    actions.setLoading(true);
    actions.setError('');
    try {
      const data = await hurricaneAlert.find();
      actions.setAlert(data);
      actions.setLastFetchedAt(Date.now());
    } catch (err) {
      actions.setError((err as Error).message || 'Failed to load storm alert');
    }
    actions.setLoading(false);
  }),

  applyPushPayload: action((state, payload) => {
    state.alert = payload;
    state.lastFetchedAt = Date.now();
  }),

  loadContent: thunk(async (actions) => {
    try {
      // Server returns array of {content_key, body_en, body_es, source, updated_at}
      const rows = await hurricaneContent.find();
      const byKey: StormContent = { prepare: null, evac: null, resources: null };
      (rows || []).forEach((row: { content_key: string }) => {
        if (row.content_key === 'prepare') byKey.prepare = row as never;
        else if (row.content_key === 'evac') byKey.evac = row as never;
        else if (row.content_key === 'resources') byKey.resources = row as never;
      });
      actions.setContent(byKey);
      actions.setContentLastFetchedAt(Date.now());
    } catch (err) {
      // Stay silent on cache-miss; users still see the previously cached version
      // eslint-disable-next-line no-console
      console.error('[storm] loadContent failed:', (err as Error).message);
    }
  }),
};

export default model;
